import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '@common/global';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { count } from 'rxjs/operators';
@Pipe({
  name: 'common'
})
export class CommonPipe implements PipeTransform {
  constructor(public sanitizer: DomSanitizer, private _global: GlobalService) { }
  transform(value: any, args?: any): any {
    let str = '';
    if (args[0] == "image") {
      let obj = value;
      if (obj != undefined) {
        let size = (args[4] == undefined) ? 'xs' : args[4];
        if( this._global.getVal(obj, args[2], '')){
        str = "/cdn/" + args[1] + "/" + this._global.getVal(obj, args[2], '') + "/" + size + "/" + this._global.getVal(obj, args[3], 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this._global.getMilliseconds() + ".png";
        }else{
          str = "/cdn/" + args[1] + "/" + obj + "/" + size + "/" + this._global.getVal(obj, args[3], 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this._global.getMilliseconds() + ".png";
        }
      }else{
      }
    } else if (args[0] == "appviewurl") {
      let obj = value;
      if (obj != undefined) {
        let s = [];
        let field = args[3].split(",")
        Object.entries(field).forEach(([key, value]) => {
          if (value == "category") {
            if (this._global.getVal(obj, value, '')) {
            let c = this._global.getVal(obj, value, '');
            s.push(this._global.removeSpecialChar(c));
            }
          }else if (value == "name" || value == "title") {
            if (this._global.getVal(obj, value, '')) {
              s.push(this._global.removeSpecialChar(this._global.getVal(obj, value, '')));
            }
          }else if (value == "addressJson") {
            let a = this._global.getVal(obj, value, '');
              if(this._global.getVal(a, 'address', '')){
                s.push(this._global.removeSpecialChar(this._global.getVal(a, 'address', '')));
              } 
              if(this._global.getVal(a, 'city', '')){
                s.push(this._global.removeSpecialChar(this._global.getVal(a, 'city', '')));
              }
              if(this._global.getVal(a, 'state', '')){
                s.push(this._global.removeSpecialChar(this._global.getVal(a, 'state', '')));
              }
          } else {
            if (this._global.getVal(obj, value, '')) {
              s.push(this._global.removeSpecialChar(this._global.getVal(obj, value, '')));
            }
          }
        });

       str =  "/"+args[1]+"/"+ s.join("-")+"-"+args[2]+"-"+btoa(this._global.getVal(value, 'id', '')) ;
     
      }
    } else if (args[0] == "pathToMediaImage") {
      let obj = value;
      if (obj != undefined) {
        let size = (args[4] == undefined) ? 'xs' : args[4];
        Object.entries(obj).forEach(([key, value]) => {
          if (value) {
            str = "/cdn/" + args[1] + "/" + this._global.getVal(value, args[2], '') + "/" + size + "/" + this._global.getVal(value, args[3], 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this._global.getMilliseconds() + ".png";
          }
        });
      }
    } else if (args[0] == "cartImage") {
      let obj = value;
      if (obj != undefined) {
        let size = (args[4] == undefined) ? 'm' : args[4];
        Object.entries(obj).forEach(([key, value]) => {
          if (value) {
            str = "/cdn/product/" + args[1] + "/" + size + "/" + this._global.getVal(value, 'name', 'noname').replace(/\s/g, "").replace(/[^a-zA-Z0-9]+/g, "-") + "_" + this._global.getMilliseconds() + ".png";
          }
        });
      }
    } else if (args[0] == "getVal") {
      str = this._global.getVal(value, args[1], args[2]);
    } else if (args[0] == "appIcon") {
      str = this._global.getAppIcon(value);
    } else if (args[0] == "limitchar") {
      if(value){
      str = value.substring(0, args[1]);
      }
    } else if (args[0] == "safe") {
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    } else if (args[0] == "innerHtml") {
      if(value!=undefined){
        return this.sanitizer.bypassSecurityTrustHtml(value);
      }
    
    } else if (args[0] == "paginationInfo") {
      str = this._global.paginateInfo(value, args[1]);
    } else if (args[0] == "averageRating") {
      str = value;
      if (str == 'NaN') {
        str = '0';
      } else {
        let n = String(value).split(".");
        if (n.length == 2) {
          let num: number = value;
          str = num.toFixed(1);
        }
      }

    }
    return str;
  }

}
